<template>
  <div>
    <h2 class="c-pageTitle">
      {{ $t('pages.CompaniesLocationStoreCompetitor.RequireCompetitorBrand.title') }}
    </h2>
    <p>{{ $t('pages.CompaniesLocationStoreCompetitor.RequireCompetitorBrand.notice') }}</p>
    <div class="c-button c-button--left">
      <router-link :to="{ name: 'CompaniesManagementCompetitorBrands', params: { company_uuid: companyUuid }}" class="c-button__item c-button__item--primary">
        {{ $t('pages.CompaniesLocationStoreCompetitor.RequireCompetitorBrand.linkToCompetitorBrands') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequireCompetitorBrand',
  computed: {
    companyUuid() {
      return this.$route.params.company_uuid
    }
  }
}
</script>
